module.exports = __webpack_public_path__ + "img/nt15-01-75-1.prt.8fd0636e.jpg";